<template>
    <app-layout title="User Management">
        <template #header>
            <div class="flex justify-between">
                <h2 class="font-semibold text-xl text-gray-800 dark:text-gray-200 leading-tight">
                    Client Management
                </h2>
                <inertia-link :href="route('admin.client.create')" class="max-w-min whitespace-nowrap flex items-center justify-between w-full px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-red-600 border border-transparent rounded-lg active:bg-red-600 hover:bg-red-700 focus:outline-none focus:shadow-outline-red">
                    Create client
                    <span class="ml-2" aria-hidden="true">+</span>
                </inertia-link>
            </div>
        </template>
        <div class="w-full overflow-hidden rounded-lg shadow">
            <table-layout>
                <template v-slot:theadRow>
                    <th class="px-4 py-3">Name</th>
                    <th class="px-4 py-3">Users</th>
                    <th class="px-4 py-3">Created at</th>
                    <th class="px-4 py-3">Status</th>
                    <th class="px-4 py-3 text-right">Actions</th>
                </template>
                <template v-slot:tbody>
                    <tr v-for="client in paginatedClients.data" class="text-gray-700 dark:text-gray-400">
                        <td class="px-4 py-3">
                            <div class="flex items-center text-sm">
                                <div>
                                    <p class="font-semibold">{{ client.name }}</p>
<!--                                    <p class="text-xs text-gray-600 dark:text-gray-400">-->
<!--                                        10x Developer-->
<!--                                    </p>-->
                                </div>
                            </div>
                        </td>
                        <td class="px-4 py-3 text-sm">
                            {{ client.userCount }}
                        </td>
                        <td class="px-4 py-3 text-sm">
                            {{ dayjs(client.created_at).format("DD-MM-YYYY HH:mm") }}
                        </td>
                        <td class="px-4 py-3 text-sm">
                            {{ clientStatuses[client.status] }}
                        </td>
                        <td class="px-4 py-3 text-right">
                            <div class="flex items-center justify-end space-x-1 text-sm">
                                <inertia-link :href="route('admin.client.edit', client.id)" class="flex items-center justify-between px-2 py-2 text-sm font-medium leading-5 text-gray-600 rounded-lg dark:text-gray-400 focus:outline-none focus:shadow-outline-gray"
                                        aria-label="Edit"
                                >
                                    <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"></path>
                                    </svg>
                                </inertia-link>
                                <inertia-link :href="route('admin.project.index', {client: client.id})"
                                   class="flex items-center justify-between px-2 py-2 text-sm font-medium leading-5 text-gray-600 rounded-lg dark:text-gray-400 focus:outline-none focus:shadow-outline-gray"
                                   aria-label="Manage Projects"
                                >
                                    <svg class="h-5 w-5 text-gray-600 dark:text-gray-400" id="Layer_1"
                                         data-name="Layer 1"
                                         xmlns="http://www.w3.org/2000/svg"
                                         fill="currentColor"
                                         viewBox="0 0 108.81 122.88">
                                        <path fill-rule="evenodd" class="cls-1"
                                              d="M62.72,69.75H99.84a9,9,0,0,1,9,9V113.9a9,9,0,0,1-9,9H62.72a9,9,0,0,1-9-9V78.72a9,9,0,0,1,9-9ZM57.35,11.06,76.24,28.69H57.35V11.06ZM20,66.89A2,2,0,0,0,18.06,69,2,2,0,0,0,20,71.15h23.7V66.89Zm0,15.26a2,2,0,0,0-1.92,2.13A2,2,0,0,0,20,86.41h23.7V82.15Zm0-45.79A2,2,0,0,0,18,38.49,2,2,0,0,0,20,40.62H41.89a2,2,0,0,0,1.91-2.13,2,2,0,0,0-1.91-2.13ZM20,21.1a2,2,0,0,0-1.92,2.13A2,2,0,0,0,20,25.36H32a2,2,0,0,0,1.91-2.13A2,2,0,0,0,32,21.1Zm0,30.53A2,2,0,0,0,18,53.76,2,2,0,0,0,20,55.89H57A2.05,2.05,0,0,0,59,53.76,2,2,0,0,0,57,51.63H20Zm66.8-20.41a3.15,3.15,0,0,0-2.29-3l-27.83-27A3.09,3.09,0,0,0,54.21,0H5.66A5.63,5.63,0,0,0,0,5.65v96.78a5.63,5.63,0,0,0,1.65,4,5.71,5.71,0,0,0,4,1.65h4.81V116a7,7,0,0,0,6.92,6.92H43.74V117H17.35a1,1,0,0,1-.7-.28,1,1,0,0,1-.28-.7v-7.89H43.76v-6.31H6.32V6.29H51V31.83A3.17,3.17,0,0,0,54.21,35H80.44V60.2h6.31V42.44h7.81a1,1,0,0,1,.71.28,1,1,0,0,1,.28.7V60.21h6V43.42a6.91,6.91,0,0,0-2-4.88,6.82,6.82,0,0,0-4.88-2H86.75V31.22Zm-7.36,76.71L67.89,111l1.66-12.34,9.84,9.28ZM72.08,95.85,84.34,82a1.06,1.06,0,0,1,.76-.36,1.17,1.17,0,0,1,.52.12l8.76,8a.9.9,0,0,1,.28.63.91.91,0,0,1-.3.71L81.89,105.12l-9.82-9.27Z"/>
                                    </svg>
                                </inertia-link>
                                <button @click.prevent="deleteClient(client)" class="flex items-center justify-between px-2 py-2 text-sm font-medium leading-5 text-gray-600 rounded-lg dark:text-gray-400 focus:outline-none focus:shadow-outline-gray"
                                        aria-label="Delete"
                                >
                                    <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </td>
                    </tr>
                </template>
            </table-layout>
            <table-pagination :pagination-object="paginatedClients"/>
        </div>
    </app-layout>
</template>

<script>
import {defineComponent} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import TablePagination from "@/Jetstream/TablePagination";
import TableLayout from "@/Jetstream/TableLayout";
import Pill from "@/Jetstream/Pill";
import { Inertia } from '@inertiajs/inertia'
import {inject} from "vue";
import dayjs from "dayjs";

export default defineComponent({
    methods: {dayjs},
    components: {
        Pill,
        TableLayout,
        TablePagination,
        AppLayout
    },
    props: {
        paginatedClients: Object,
    },
    data() {
        return {
            title: "Test"
        }
    },
    setup() {
        const $swal = inject('$swal');
        const deleteClient = (client) => {
            $swal({
                title: 'Are you sure you want to delete this client?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    Inertia.delete(route('admin.client.destroy', client.id));
                }
            });
        };
        const clientStatuses = {
            0: 'Prospect',
            1: 'Client',
        };

        return {
            deleteClient,
            clientStatuses
        };
    }
})
</script>
